import React from 'react';

import Button from '@ulta/core/components/Button/Button';

import { spreadProps } from '../dom/dom';

/**
 * Function for button action style
 * @function getButtonHtml
 * @param { object }  - returns an object with the appropriate HTML markup
 */
export const getButtonHtml = ( data ) => {
  const {
    action,
    actionSize,
    actionStyle,
    derivedAriaLabel,
    fullyClickableParent,
    isKnockoutLink,
    textForScreenReaders
  } = data;

  /* Determine if the button needs a negative tab index */
  const hasNegIndex = ( !textForScreenReaders && fullyClickableParent );
  const updateTabIndex = hasNegIndex ? -1 : undefined;
  const updateAriaHidden = hasNegIndex ? true : undefined;

  /* Determine if aria-label is needed */
  const needAriaLabel = !hasNegIndex && !textForScreenReaders;
  const updateAriaLabel = needAriaLabel ? derivedAriaLabel : undefined;

  return (
    <>
      <Button
        { ...action }
        { ...spreadProps( {
          ariaHidden: updateAriaHidden
        } ) }
        action={ action } // We need to pass this specifically for the action to work with DC and everything else that comes with the web-site Button. Palette bundles this as one object and doesn't compose the action props the way web-site needs them. We did this this way to keep business logic out of Palette
        ariaLabel={ updateAriaLabel }
        fullyClickableParent={ fullyClickableParent }
        isKnockoutLink={ isKnockoutLink }
        screenReaderText={ derivedAriaLabel }
        size={ actionSize }
        tabIndex={ updateTabIndex }
        variant={ actionStyle }
      />
    </>
  );
};